"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBPART_L_NOT_ADOPTED = void 0;
exports.getEpisodicRelief = getEpisodicRelief;
exports.episodicEventsApplicableForState = episodicEventsApplicableForState;
const states_1 = require("encamp-shared/dist/constants/states");
const facilityState_1 = require("../facilityState");
const UTC_MONTH = new Intl.DateTimeFormat("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
});
/**
 * States that have not adopted subpart L. A less-stringent federal provision
 * does not apply in an authorized state until the state adopts it
 * (40 CFR 271.1(i)(2)). The "adopted everywhere else" default is unconfirmed
 * by the waste SME; see `EPISODIC_EXPECTATIONS`.
 */
exports.SUBPART_L_NOT_ADOPTED = new Set([
    "CA",
    "CT",
    "MA",
    "MN",
]);
function getEpisodicRelief(query) {
    const state = (0, facilityState_1.parseFacilityState)(query.state);
    if (state !== null && exports.SUBPART_L_NOT_ADOPTED.has(state)) {
        const stateName = states_1.stateNamesByAbbreviation.get(state) ?? state;
        return {
            isAvailable: false,
            reasonKind: "STATE_NOT_ADOPTED",
            reason: `${stateName} hasn't adopted the episodic event provision (40 CFR 262 subpart L), ` +
                "so the event will be recorded, but generator status and deadlines won't change",
        };
    }
    if (query.generatorStatus === "LQG") {
        const when = query.period ? ` for ${UTC_MONTH.format(query.period)}` : "";
        return {
            isAvailable: false,
            reasonKind: "LQG",
            reason: `This facility is a Large Quantity Generator (LQG)${when}, so an episodic event likely ` +
                "isn't required — subpart L only protects VSQGs and SQGs from moving up a generator " +
                "category. If you declare it anyway, waste you tie to the event within its 60-day " +
                "window won't count toward generator status.",
        };
    }
    // Null status included: an unresolved tier is no evidence the facility is an LQG.
    return { isAvailable: true };
}
/**
 * The state axis alone — the one thing besides attachment that gates
 * behavior, and what the UI uses to hide the feature in non-adopting states.
 * `null` answers federally.
 */
function episodicEventsApplicableForState(state) {
    const parsed = (0, facilityState_1.parseFacilityState)(state);
    return parsed === null || !exports.SUBPART_L_NOT_ADOPTED.has(parsed);
}
//# sourceMappingURL=relief.js.map